import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {routes} from '../Constants';

const PrivateRoutes = (props) => {
    const isAuth = localStorage.getItem('token');


    return (!isAuth ? <Redirect to={routes.App.Login}/> : <Route {...props}>{props.children}</Route>);
};

export default PrivateRoutes;